<template>
  <section>

      <!-- Component for question title, description, number and required indicator -->
      <question-header />

      <!-- Specific markup for this question type -->
      <div class="columns">

        <div class="column is-four-fifths dropdown-padding" v-if="questionData.question_type == 'select_multiple_one'">
          <vue-dropdown
            :config="config"
            @setSelectedOption="saveAnswer($event)"
            class="dropdown">
          </vue-dropdown>
        </div>

        <div class=" is-four-fifths" v-if="questionData.question_type == 'calendar'">
          <datepicker input-class="input" placeholder="Selecteer datum" v-bind:full-month-name="true" :language="nl" class="calendar" format="d MMMM yyyy" @selected="saveAnswer($event)"/>
        </div>

        <div class=" is-four-fifths" v-if="questionData.question_type == 'value'">
          <b-input icon="euro-sign" icon-size="is-large" icon-pack="fas" placeholder="0" v-model="moneyString" class="money" @blur="saveAnswer">
          </b-input>
        </div>

        <div v-if="questionData.question_type == 'checkbox_multiple_multiple'">
          <div
          v-for="(val, index) in questionData.values"
          class="field">
            <p-check class="p-default p-curve p-fill p-smooth p-bigger is-size-5 checkbox-option" :value="val" v-model="questionData.answer" @change="saveAnswer">{{ val }}</p-check>
          </div>
        </div>

        <div class="column is-four-fifths" v-if="questionData.question_type == 'text'">
          <b-input v-model="questionData.answer" class="text-input" placeholder="Type hier een antwoord..." type="textarea" @blur="saveAnswer">
          </b-input>
        </div>

      </div>

        <!-- button area (right side of question card) -->


      </div>
      <br>
      <div v-if="questionData.question_type == 'select_multiple_one'">
        <br><br>
      </div>

    <!-- Comment component to be redered when comments are allowed for this question -->

  </section>
</template>

<script>
import QuestionHeader from './QuestionHeader'
import QuestionOptions from './QuestionOptions'
import CommentBox from './CommentBox'

export default {
  components: {
    'question-header': QuestionHeader,
    'question-options': QuestionOptions,
    'comment-box': CommentBox
  },
  props: {
    questionData: Object, // eslint-disable-line vue/require-default-prop
    number: Number // eslint-disable-line vue/require-default-prop
  },
  data () {
    return {
      radio: 'default',
      comment: {
        showComment: false,
        commentFocussed: false,
        questionIsFocussed: false
      },
      array: [],
      moneyString: '',
      config: {
        options: [],
        placeholder: 'Selecteer...',
        backgroundColor: '#f2f2f2',
        textColor: 'black',
        borderRadius: '5px',
        // border: '1px solid gray',
        width: 350
      }
    }
  },
  created () {
    this.questionData.values.forEach((value) => {
      let option = {};
      option.value = value;
      this.config.options.push(option)
    });
    if (this.questionData.question_type == 'checkbox_multiple_multiple' && this.questionData.answer == null) this.questionData.answer = []
    if (this.questionData.answer) this.config.placeholder = this.questionData.answer

  },
  methods: {
    saveAnswer (selected) {
      if (this.questionData.question_type == 'calendar')
      {
        this.config.placeholder = selected.getTime()/1000
        this.questionData.answer = selected.getTime()/1000
      }
      else if (this.questionData.question_type == 'select_multiple_one')
      {
        this.config.placeholder = selected.value
        this.questionData.answer = selected.value
      }
      else if (this.questionData.question_type == 'value')
      {
        this.questionData.answer = parseInt(this.moneyString.toString().replace(/[.,][0-9][0-9]?$/g, '').replace(/[.,]/g, ''));
        this.moneyString = this.questionData.answer.toLocaleString('nl-NL') + ',–';
      }

      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')))
    },
    checkbox(selected) {
      // console.log(selected);
    }
  },
  provide () {
    return {
      question: this.questionData,
      number: 0,
      comment: this.comment
    }
  }
}
</script>

<style scoped>

  .dropdown-question {
    z-index: 12;
  }

  .dropdown-padding {
    height: 80px;
  }
  .md-checkbox {
    display: flex;
  }
  .money {
    margin-left: 0.7em;
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/Property.vue